import props from './props'

export default {
  props
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/components/resources/index.js